export const LANGUAGE_FLAGS: Record<string, string> = {
  en: '🇬🇧',
  no: '🇳🇴',
};